import axios from 'axios';

const clientPortalClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

clientPortalClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('studioSivadClientAuth');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const selectedBrandId = localStorage.getItem('studioSivadClientBrandId');
  if (selectedBrandId) {
    config.headers['x-client-brand-id'] = selectedBrandId;
  }
  return config;
});

export default clientPortalClient;
